import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, Tooltip } from 'recharts';
import { GRAPH_STATUSES } from '../../../constants/constants';
import './StackedBarChart.scss';

const StackedBarChart = ({ title, data, width, onClick}) => {

    const convertDataKeyToDisplayName = (key) => {
        switch(key) {
            case GRAPH_STATUSES.Complete.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.Complete.id.slice(1):
                return GRAPH_STATUSES.Complete.label;
            case GRAPH_STATUSES.InProgress.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.InProgress.id.slice(1):
                return GRAPH_STATUSES.InProgress.label;
            case GRAPH_STATUSES.PastDue.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.PastDue.id.slice(1):
                return GRAPH_STATUSES.PastDue.label;
            case GRAPH_STATUSES.NotDue.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.NotDue.id.slice(1):
                return GRAPH_STATUSES.NotDue.label;
        }
    }
    const CustomTooltip = (args) => {
        if (args.active) {
          return (
            <div className="custom-tooltip">
              <div className="date">{args.label}</div>
              {args.payload && args.payload.map(item => 
                    <div key={item.dataKey} className="data-key-item" style={ { color: item.fill } }>
                        {convertDataKeyToDisplayName(item.dataKey)}: {item.payload[item.dataKey]}
                    </div>
              )}
            </div>
          );
        }
      
        return null;
    }

    const handleClick = (data, index) => {
        if(onClick){
            onClick(data, index);
        }
      }

    return (
        <div className="stacked-bar-chart">
            <BarChart width={width} height={160} data={data}
                margin={{top: 20, right: 0, left: -20, bottom: 5}}>
                <XAxis dataKey="name" stroke="#ccc"/>
                <YAxis stroke="#ccc"/>
                <Tooltip content={<CustomTooltip />} cursor={false} />
                <Bar onClick={handleClick} barSize={26} dataKey={GRAPH_STATUSES.Complete.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.Complete.id.slice(1)} stackId="a" fill={GRAPH_STATUSES.Complete.color} />
                <Bar onClick={handleClick} barSize={26} dataKey={GRAPH_STATUSES.InProgress.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.InProgress.id.slice(1)} stackId="a" fill={GRAPH_STATUSES.InProgress.color} />
                <Bar onClick={handleClick} barSize={26} dataKey={GRAPH_STATUSES.PastDue.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.PastDue.id.slice(1)} stackId="a" fill={GRAPH_STATUSES.PastDue.color} />
                <Bar onClick={handleClick} barSize={26} dataKey={GRAPH_STATUSES.NotDue.id.charAt(0).toLocaleLowerCase() + GRAPH_STATUSES.NotDue.id.slice(1)} stackId="a" fill={GRAPH_STATUSES.NotDue.color} />
            </BarChart>
            <div className="title">{title}</div>
        </div>
    );

};
StackedBarChart.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    width: PropTypes.number.isRequired,
    onClick: PropTypes.func
};

export default StackedBarChart;
